import { Typography, MenuItem, Stack } from '@mui/material';
import {
  FormSection,
  FileUpload,
  RadioButtons,
  CustomCheckbox,
} from 'Components';
import { ControllerSelect } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useAppSelector, useDictionary, useDispatchApp } from 'Hooks';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { setIsRequestAllowanceWasSubmitted } from 'Store/requestAndEarlyAcquaintanceSlice';
import { isFileExist } from 'Utils/isFileExist';

export const FirstSection = () => {
  const filesList = useAppSelector(({ file: { files } }) => files);

  const requestTypes = useAppSelector(
    ({
      generalContent: {
        generalContent: { requestReasonTypes },
      },
    }) => requestReasonTypes
  );

  const isRequestAllowanceWasSubmittedName = 'isRequestAllowanceWasSubmitted';
  const isRequestProcessingEndedName =
    'socialSecurityRequestSection.isRequestProcessingEnded';

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.REQUEST_AND_EARLY_ACQUAINTANCE
  );

  const isRequestAllowanceWasSubmitted = useWatch({
    name: isRequestAllowanceWasSubmittedName,
    defaultValue: false,
  }) as boolean;

  const [hasNoSocialSecurityProtocol] = useWatch({
    name: ['socialSecurityRequestSection.hasNoSocialSecurityProtocol'],
  });

  const isRequestProcessingEnded = useWatch({
    name: isRequestProcessingEndedName,
    defaultValue: false,
  }) as boolean;

  const dispatch = useDispatchApp();

  useEffect(() => {
    dispatch(setIsRequestAllowanceWasSubmitted(isRequestAllowanceWasSubmitted));
  }, [isRequestAllowanceWasSubmitted, dispatch]);

  return (
    <FormSection>
      <Typography
        sx={{ fontWeight: 'bold', fontSize: '16px!important' }}
        variant={'h2'}
      >
        {dictionary.firstSectionTitle}
      </Typography>
      <RadioButtons
        name={isRequestAllowanceWasSubmittedName}
        options={[
          {
            value: 'true',
            label: dictionary.firstSectionToggleButtonRightLabel,
          },
          {
            value: 'false',
            label: dictionary.firstSectionToggleButtonLeftLabel,
          },
        ]}
        id={dictionary.firstSectionFirstInputTitle}
      />
      {isRequestAllowanceWasSubmitted && (
        <>
          <ControllerSelect
            label={dictionary.firstSectionCollapseSecondInput}
            name='socialSecurityRequestSection.requestReasonId'
          >
            {requestTypes.map(({ id, value }) => (
              <MenuItem key={id} value={id}>
                {value}
              </MenuItem>
            ))}
          </ControllerSelect>

          <RadioButtons
            name={isRequestProcessingEndedName}
            options={[
              {
                value: 'true',
                label: dictionary.firstSectionToggleButtonRightLabel,
              },
              {
                value: 'false',
                label: dictionary.firstSectionToggleButtonLeftLabel,
              },
            ]}
            id={dictionary.firstSectionSecondInputTitle}
          />

          {isRequestProcessingEnded && (
            <>
              <Typography sx={{ fontWeight: 'bold', fontSize: '14px', mt: 2 }}>
                {dictionary.firstSectionUploadFilesTitle}
              </Typography>
              <Typography sx={{ fontSize: '14px' }}>
                {dictionary.firstSectionUploadFilesInfo1}
              </Typography>
              <Typography sx={{ fontSize: '14px' }}>
                {dictionary.firstSectionUploadFilesInfo2}
              </Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: '14px', mt: 2 }}>
                {dictionary.firstSectionCollapseFirstFileUploadLabel}
              </Typography>
              <Stack>
                <FileUpload
                  dataRequired={
                    isRequestProcessingEnded && !hasNoSocialSecurityProtocol
                  }
                  fileCategoryId={FileCategories.SocialSecurityProtocol}
                  fileLabel={
                    dictionary.firstSectionCollapseFirstFileUploadLabel
                  }
                  ariaLabel={
                    dictionary.firstSectionCollapseFirstFileUploadTitle
                  }
                  disabled={hasNoSocialSecurityProtocol}
                />
                {!isFileExist(
                  filesList,
                  FileCategories.SocialSecurityProtocol
                ) && (
                  <CustomCheckbox
                    name={
                      'socialSecurityRequestSection.hasNoSocialSecurityProtocol'
                    }
                    label={dictionary.firstSectionNoData}
                  />
                )}
              </Stack>
            </>
          )}
        </>
      )}
    </FormSection>
  );
};
